import { render, staticRenderFns } from "./iRechargePay.vue?vue&type=template&id=21e5275c&scoped=true&"
import script from "./iRechargePay.vue?vue&type=script&lang=js&"
export * from "./iRechargePay.vue?vue&type=script&lang=js&"
import style0 from "./iRechargePay.vue?vue&type=style&index=0&id=21e5275c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e5275c",
  null
  
)

export default component.exports